export default __webpack_public_path__ + "static/media/2.18fea4cb.png";